var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-upload-file",
      attrs: {
        show: _vm.show,
        title: _vm.modalTitle,
        saveButton: {
          visible: false,
        },
        cancelButton: {
          visible: false,
        },
        size: "small",
        needHeader: true,
        needFooter: false,
        relativeBackdrop: true,
        centered: true,
        contentCentered: true,
      },
      on: { close: _vm.onClose },
    },
    [
      _c(
        "form",
        {
          attrs: { autocomplete: "off" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("div", { staticClass: "d-flex", attrs: { role: "body" } }, [
            _c(
              "div",
              { staticStyle: {} },
              [
                _c("div", { staticClass: "file-upload-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card card-body view file-upload",
                      class: {
                        "has-preview": _vm.hasFiles,
                        "has-error": _vm.hasErrors,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card-text file-upload-message" },
                        [
                          _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
                          _vm._v(" "),
                          _c("p", {
                            domProps: { innerHTML: _vm._s(_vm.txtImport) },
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "file-upload-error" }, [
                            _vm._v(_vm._s(_vm.msgError)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mask rgba-stylish-slight" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "file-upload-errors-container" },
                        [
                          _c(
                            "ul",
                            _vm._l(_vm.importErrors, function (error, idx) {
                              return _c("li", { key: idx }, [
                                _vm._v(_vm._s(error)),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "file_upload",
                        attrs: {
                          type: "file",
                          id: "input-file",
                          accept: _vm.allowedFileTypes,
                          "data-max-file-size": "2M",
                        },
                        on: { change: _vm.onUploadFile },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm btn-danger waves-effect waves-light",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onRemoveFile.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v("\n                            Remove"),
                          _c("i", { staticClass: "far fa-trash-alt ml-1" }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-upload-preview" }, [
                        _c("span", { staticClass: "file-upload-render" }, [
                          _c("i", { staticClass: "fas fa-file" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "file-upload-extension" }, [
                            _vm._v(_vm._s(_vm.fileExtension)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "file-upload-infos" }, [
                          _c(
                            "div",
                            { staticClass: "file-upload-infos-inner" },
                            [
                              _c("p", { staticClass: "file-upload-filename" }, [
                                _c(
                                  "span",
                                  { staticClass: "file-upload-filename-inner" },
                                  [_vm._v(_vm._s(_vm.fileName))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "file-upload-infos-message",
                                domProps: {
                                  innerHTML: _vm._s(_vm.txtPreviewUpload),
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._t("default"),
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }